import { useNavigate } from 'react-router-dom';
import { usePlans } from '~/app/hooks/maintenance/usePlans';
import type { PlanRow } from '../types';

export function usePreventiveMaintenancePage() {
  const navigate = useNavigate();
  const { plans, isLoading } = usePlans();

  const rows: PlanRow[] = plans.map((plan) => ({
    id: plan.id,
    code: plan.code,
    name: plan.name,
    priority: plan.priority,
    active: plan.active,
    createdAt: plan.createdAt,
  }));

  const goToCreate = () => {
    navigate('/maintenance/preventive/create');
  };

  const goToPlan = (planId: string) => {
    navigate(`/maintenance/preventive/${planId}`);
  };

  return {
    rows,
    isLoading,
    goToCreate,
    goToPlan,
  };
}
